var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.25L4.2 12.6A4.8 4.8 0 1111 5.8l1 1 1-1a4.8 4.8 0 116.8 6.8L12 20.25z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
}
export default SvgHeart;